export async function hash(string) {
    if (typeof crypto !== 'undefined' && crypto.subtle) {
        const utf8 = new TextEncoder().encode(string);
        const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(bytes => bytes.toString(16).padStart(2, '0')).join('');
    }
    const nodeCrypto = require('crypto');
    return nodeCrypto.createHash('sha256').update(string).digest('hex');
}
export const DOC_ASSIST_BASE_EXTENSION_URL = 'https://lumeris.com/fhir/CodeSystem/DocumentationAssistant';
//# sourceMappingURL=utils.js.map